// Centrální slovník pro překlad známých syrových chybových hlášek z backendu
// (mix češtiny/angličtiny, SQL výjimky, Symfony security zprávy) na jednotný,
// uživatelsky čitelný text. Neznámé/nezmapované hlášky se vrací beze změny
// (žádný generický "catch-all" - ten je záměrně jen v main.js safety-netu
// pro neočekávané JS chyby, ne pro API chyby, které chceme co nejpřesněji
// popsat).
//
// Mimo Vue komponenty (volá se z fetch.js) - proto i18n singleton přímo,
// ne this.$t().
import i18n from '@/i18n';

const ERROR_DICTIONARY = [
    // ApiTokenAuthenticator.php - neplatný/expirovaný token
    { match: 'Neplatný nebo expirovaný token', key: 'common.apiErrors.sessionExpired' },
    { match: 'Neplatný formát tokenu', key: 'common.apiErrors.sessionExpired' },
    { match: 'Chybí Authorization header', key: 'common.apiErrors.sessionExpired' },
    // LoginController.php - přihlášení
    { match: 'Neplatné přihlašovací údaje', key: 'common.apiErrors.invalidCredentials' },
    { match: 'Chybí e-mail nebo heslo', key: 'common.apiErrors.missingCredentials' },
    { match: 'Trainer not known', key: 'common.apiErrors.invalidCredentials' },
    // ChangePassword.php
    { match: 'Bad current password', key: 'common.apiErrors.currentPasswordIncorrect' },
    { match: 'Toto jméno už někdo používá', key: 'common.apiErrors.nameTaken' },
    // Duplicitní jméno trenéra (Unique violation index 7) + syrový SQL text,
    // pokud by přece jen prosákl (viz EditProfile.vue historie)
    { match: 'Unique violation: 7', key: 'common.apiErrors.nameTaken' },
    { match: 'Duplicate entry', key: 'common.apiErrors.nameTaken' },
    // Obecný fallback pro 401 bez rozpoznané hlášky
    { match: 'Unauthorized', key: 'common.apiErrors.sessionExpired' },
    // PositionService.php/TravelAction.php - dojdou kroky uprostred cesty
    { match: 'Not enought steps', key: 'common.notEnoughSteps' },
    // PvP flow (ChoosePvpSkillAction/ChoosePvpPokemonAction/DeclinePvpAction/
    // ChallengePvpAction/RecallPvpPokemonAction/AcceptPvpAction/GetPvpAction/
    // SurrenderPvpAction/PvpService.php) - zastaraly stav zapasu, race condition
    { match: 'Zápas nenalezen.', key: 'common.apiErrors.matchNotFound' },
    { match: 'Trenér nenalezen.', key: 'common.apiErrors.trainerNotFound' },
    { match: 'Pokémon nenalezen.', key: 'common.apiErrors.pokemonNotFound' },
    { match: 'Nejsi účastník tohohle zápasu.', key: 'common.apiErrors.notMatchParticipant' },
    // Player messaging (GetPlayerMessagesAction/GetPlayerConversationsAction/SendPlayerMessageAction)
    { match: 'Trainer not found.', key: 'common.apiErrors.trainerNotFound' },
    { match: 'Receiver not found.', key: 'common.apiErrors.receiverNotFound' },
    { match: 'Cannot message yourself.', key: 'common.apiErrors.cannotMessageYourself' },
    { match: 'Message text cannot be empty.', key: 'common.apiErrors.messageTextEmpty' },
];

export function translateError(rawMessage) {
    if (!rawMessage) return '';
    const hit = ERROR_DICTIONARY.find(({ match }) => rawMessage.includes(match));
    return hit ? i18n.t(hit.key) : rawMessage;
}
